import React, { Fragment, useCallback, useRef } from 'react'

import { MIXPANEL_EVENTS } from 'lib/mixpanel/events'
import { trackMixpanelEvent } from 'lib/mixpanel/track'
import styled from 'styled-components'

import { ProgressBar, StepError } from '..'
import { Text } from '../../../../components/v2/Text'
import { setMatchMakerQuestion } from '../../../../services/match-maker'

import { Column } from 'components/v2/Grid'

const HelpReasonStep = ({
	state,
	dispatch,
	goToNextStep,
	goToPreviousStep,
	maxSteps
}) => {
	const hasTrackedSymptomWrite = useRef(false)

	const trackSymptomWriteOnce = useCallback(() => {
		if (hasTrackedSymptomWrite.current) return
		hasTrackedSymptomWrite.current = true
		trackMixpanelEvent(MIXPANEL_EVENTS.match.symptom_write_clicked)
	}, [])

	const submitHelpReasonStep = useCallback(async () => {
		dispatch({ type: 'set_status', payload: 'loading' })
		try {
			const { data } = await setMatchMakerQuestion({
				id_session: state.id_session,
				answers: [
					{
						question: state.questions[2].id,
						answer: state.form_values.help_reason
					}
				]
			})
			goToNextStep(data)
		} catch {
			dispatch({ type: 'set_status', payload: 'error' })
		}
	}, [
		dispatch,
		goToNextStep,
		state.form_values.help_reason,
		state.id_session,
		state.questions
	])

	if (state.status === 'error') {
		return (
			<StepError
				stepImage='/static/images/match-maker/03.png'
				submitStep={submitHelpReasonStep}
			/>
		)
	}

	return (
		<Fragment>
			<div className='step__illustration lg:hidden'>
				<img src='/static/images/match-maker/03.png' width='100%' />
			</div>
			<div className='step__question'>
				<p className='step__question__title'>
					Por qual motivo você busca ajuda?
				</p>
				<p className='step__question__description'>
					Vamos encontrar um psicólogo com a especialidade adequada para te
					ajudar
				</p>
				<div className='step__question__template mb-5'>
					<StyledTextArea
						placeholder='Nos conte o que está passando'
						value={state.form_values.help_reason}
						onFocus={trackSymptomWriteOnce}
						onChange={(e) => {
							trackSymptomWriteOnce()
							dispatch({ type: 'set_help_reason', payload: e.target.value })
						}}
						style={{ height: '100px', fontSize: '14pt' }}
					/>
				</div>
				<Column className='-mt-5 mb-3'>
					<ExampleText>“Tenho problema em conversar com meus pais“</ExampleText>
					<ExampleText>“Quero me conhecer melhor“</ExampleText>
					<ExampleText>“A bebida está atrapalhando minha vida“</ExampleText>
				</Column>
				<div className='step__question__info mt-5'>
					<div className='step__question__info__next-step-container'>
						<div className='step__question__info__next-step-container__navigation'>
							<button
								className='button-verm-leaked match-maker-button mr-3'
								onClick={goToPreviousStep}
							>
								Voltar
							</button>
							<button
								disabled={!state.can_proceed}
								className='button-verm match-maker-button'
								onClick={submitHelpReasonStep}
								id='step3-matchmaking'
							>
								Próximo
							</button>
						</div>
						{state.current_step > 0 && (
							<ProgressBar maxSteps={maxSteps} visualStep={state.visual_step} />
						)}
					</div>
				</div>
			</div>
		</Fragment>
	)
}

const ExampleText = styled(Text)`
	margin: 8px;
	font-style: italic;
`
const StyledTextArea = styled.textarea`
	border: 1px solid #bdc3c7;
	border-radius: 4pt;
	width: 100%;
	color: #212121;
	font-size: 16px;
	padding: 16px 12px !important;
	width: 100%;
	transition: all 0.3s;
	&::placeholder {
		color: #7f8c8d;
		font-size: 16px;
	}
	&:focus {
		outline: none !important;
		border: 1px solid #ff7708;
	}
`

export { HelpReasonStep }
